var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    d: "M16.5,41.5h15c5.522,0,10-4.478,10-10v-15 c0-5.523-4.478-10-10-10h-15c-5.523,0-10,4.477-10,10v15C6.5,37.022,10.977,41.5,16.5,41.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    d: "M24,15.5c-4.694,0-8.5,3.806-8.5,8.5 s3.806,8.5,8.5,8.5s8.5-3.806,8.5-8.5S28.694,15.5,24,15.5z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34,12c-1.105,0-2,0.895-2,2s0.895,2,2,2s2-0.895,2-2S35.105,12,34,12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.de89da7197492d4e6d4ff2c2454fdcb8.svg";
export { ForwardRef as ReactComponent };